import { useMemo } from 'react';
import { serviceOptions } from '../../../../functions/serviceOptions';

export const useGetProduct = ({ items = [], watch }) => {
  const { mobileBrandId, mobileModelId } = watch();
  const mobileData = items?.length > 0 ? items[0]?.mobilebrands : [];
  const mobileBrandOptions = useMemo(
    () => serviceOptions('MOBILE_BRAND', mobileData),
    [mobileData],
  );

  const mobileModelOptions = useMemo(
    () =>
      serviceOptions(
        'MOBILE_MODEL',
        mobileBrandOptions?.find((el) => el.value === mobileBrandId)?.mobileModels,
      ),
    [mobileBrandOptions, mobileBrandId],
  );

  const productOptions = useMemo(
    () =>
      serviceOptions(
        'PRODUCT',
        mobileModelOptions?.find((el) => el.value === mobileModelId)?.products,
      ),
    [mobileModelOptions, mobileModelId],
  );

  return {
    mobileBrandOptions,
    mobileModelOptions,
    productOptions,
  };
};
